<template>
  <filtertron-tray-section
    v-if="tab.type === 'Attachments'"
    id="tab-configurator-file-types"
    :title="lang.get('tabs.configuration.file_types.label')"
    :initially-collapsed="true"
  >
    <div class="fields island">
      <div
        v-for="(group, groupName) in fileTypes"
        :key="groupName"
        class="island"
      >
        <b>{{ lang.get('files.types.' + groupName) }}</b>
        <checkbox-group
          :group-name="groupName"
          :group="group"
          :selected="tab.attachmentAllowedFileTypes[groupName] || []"
          :select-all-label="lang.get('miscellaneous.select_all')"
          @selected="onSelected"
        />
      </div>
    </div>
  </filtertron-tray-section>
</template>

<script>
import { mapState } from 'vuex';
import CheckboxGroup from '@/lib/components/Shared/CheckboxGroup';
import FiltertronTraySection from '@/lib/components/Filtertron/FiltertronTraySection';
import handleInputMixin from '../handle-input-mixin.js';

export default {
  inject: ['lang'],
  components: {
    CheckboxGroup,
    FiltertronTraySection
  },
  mixins: [handleInputMixin],
  props: {
    tab: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('entryForm', ['fileTypes'])
  },
  methods: {
    onSelected(checked, unchecked) {
      let selected = {};

      Object.keys(this.fileTypes).forEach(group => {
        selected[group] = this.fileTypes[group].filter(
          t =>
            checked.includes(t) ||
            (this.tab.attachmentAllowedFileTypes[group] &&
              this.tab.attachmentAllowedFileTypes[group].includes(t) &&
              !unchecked.includes(t))
        );
      });

      Object.keys(selected).forEach(group => {
        if (selected[group].length === 0) {
          delete selected[group];
        }
      });

      this.$emit('input', {
        attachmentAllowedFileTypes: selected
      });
    }
  }
};
</script>
